import React from 'react'
import { Page, PageProps } from '../../components/Page/Page'
import { Styled } from '../../utils/Stylable'

export const SettingsPage = React.memo<Styled<PageProps>>((props: Styled<PageProps>) => (
  <Page {...props} className={`flex flex-col p-0 ${props.className}`} disableLayout={false} />
))

SettingsPage.displayName = 'SettingsPage'
